module.exports = __webpack_public_path__ + "img/bl-bg.4e433f1d.png";